<template>
  <kst-table checkable paginated view-mode
    :data="items"
    :custom-is-checked="customIsChecked"
    :checked-rows.sync="userData.checkedRows"
    @check="handleCheck"
  >
    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-image"
      field="ImageSrc"
      :label="Catalog.ImageSrc.Label"
    >
      <kst-image read-only thumbnail :src="row[column.field]"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      field="Name"
      :label="Catalog.Name.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-sku"
      field="SKU"
      :label="Catalog.SKU.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <b-table-column
      v-slot="{ column, row }"
      cell-class="ks-col-packaging"
      field="PackagingName"
      :label="Catalog.PackagingName.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog">
        ({{ row.PackagingQty }})
      </kst-value>
    </b-table-column>

    <b-table-column numeric
      v-slot="{ column, row }"
      cell-class="ks-col-qty has-text-weight-bold"
      field="Quantity"
      :label="Catalog.Quantity.Label"
    >
      <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
    </b-table-column>

    <template v-if="sellPrice">
      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="Catalog.SellPrice.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
      </b-table-column>
    </template>

    <template v-if="weight">
      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-weight"
        field="Weight"
        :label="Catalog.Weight.Label"
      >
        <kst-value :field="column.field" :data="row" :catalog="Catalog"/>
      </b-table-column>
    </template>
  </kst-table>
</template>

<script>
import SnackbarMixin from "../../../mixins/SnackbarMixin.js";
import Catalog from "../StkCatalog.js";
import Model from "../StkModel.js";

export default {
  mixins: [SnackbarMixin],
  props: {
    items: Array,
    userData: Object,
    maxSelectable: Number,
    // field visibility (order by appearance)
    sellPrice: Boolean,
    weight: Boolean
  },
  data: () => ({
    Catalog: Catalog,
    Model: Model
  }),
  watch: {
    // new search result replaces the list → clear stale checked rows,
    // so rows from previous search are not silently submitted
    items() {
      this.userData.checkedRows = [];
    }
  },
  methods: {
    customIsChecked(selectedRow, row) {
      return selectedRow.ItemID === row.ItemID;
    },
    handleCheck(checkedList) {
      // limit: maximal checked rows in one batch select
      if (checkedList.length > this.maxSelectable) {
        // revert: keep only allowed count, uncheck the rest
        this.userData.checkedRows = checkedList.slice(0, this.maxSelectable);
        this.notifyFormError(false, this.getMaxSelectableMessage());
        return;
      }

      this.$emit(this.$kst.Enum.Event.Check, checkedList);
    },
    getMaxSelectableMessage() {
      return "Maksimal " + this.maxSelectable + " " +
        this.Model.Item.Module.FullName.toLowerCase() +
        " dalam sekali pilih. Sisanya dapat ditambahkan pada transaksi lain.";
    }
  }
}
</script>